import { BackOfficePermissionRoleClaim } from '@/../client-generator/generated-clients/user';
import TheContainer from '@/views/containers/TheContainer/TheContainer.vue';
import { RouteConfig } from 'vue-router';
import { APP_TITLE } from '../utilities/appconsts';

const Dashboard = () => import(/* webpackChunkName: "page-dashboard" */ '@/views/pages/Dashboard/Dashboard.vue');
const Page404 = () => import(/* webpackChunkName: "page-404" */ '@/views/pages/Page404/Page404.vue');
const LoginPage = () => import(/* webpackChunkName: "page-404" */ '@/views/pages/Login/Login.vue');

const EnableUserPage = () =>
  import(/* webpackChunkName: "page-enable-user" */ '@/views/pages/EnableUser/EnableUser.vue');
const SyncPage = () => import(/* webpackChunkName: "page-sync" */ '@/views/pages/Sync/Sync.vue');
const CustomersPage = () =>
  import(/* webpackChunkName: "page-customers-active" */ '@/views/pages/Customers/Customers.vue');
const CustomersToActivatePage = () =>
  import(
    /* webpackChunkName: "page-customers-to-activate" */ '@/views/pages/Customers/CustomersToActivate/CustomersToActivate.vue'
  );
const ActivateCustomerPage = () =>
  import(
    /* webpackChunkName: "page-activate-customer" */ '@/views/pages/Customers/ActivateCustomer/ActivateCustomer.vue'
  );
const CustomerDetailPage = () =>
  import(/* webpackChunkName: "page-customer-detail" */ '@/views/pages/Customers/CustomerDetail/CustomerDetail.vue');
const RecoverPasswordPage = () =>
  import(/* webpackChunkName: "page-password-recover" */ '@/views/pages/RecoverPassword/RecoverPassword.vue');
const ResetPasswordPage = () =>
  import(/* webpackChunkName: "page-password-reset" */ '@/views/pages/ResetPassword/ResetPassword.vue');
const ChangePasswordPage = () =>
  import(/* webpackChunkName: "page-change-password" */ '@/views/pages/ChangePassword/ChangePassword.vue');
const JobTasksListPage = () =>
  import(/* webpackChunkName: "page-jobtasks-list" */ '@/views/pages/JobTasks/JobTasksList/JobTasksList.vue');
const JobTasksDetailPage = () =>
  import(/* webpackChunkName: "page-jobtasks-detail" */ '@/views/pages/JobTasks/JobTaskDetail/JobTaskDetail.vue');
const SitesListPage = () =>
  import(/* webpackChunkName: "page-sites-list" */ '@/views/pages/Sites/SitesList/SitesList.vue');
const SitesDetailPage = () =>
  import(/* webpackChunkName: "page-sites-detail" */ '@/views/pages/Sites/SiteDetail/SiteDetail.vue');
const ContactsListPage = () =>
  import(/* webpackChunkName: "page-contacts-list" */ '@/views/pages/Contacts/ContactsList/ContactsList.vue');
const ContactDetailPage = () =>
  import(/* webpackChunkName: "page-contact-detail" */ '@/views/pages/Contacts/ContactDetail/ContactDetail.vue');
const ContactDetailDocumentUploadPage = () =>
  import(
    /* webpackChunkName: "page-contact-detail" */ '@/views/pages/Contacts/ContactDetail/ContactDetailDocuments/ContactDetailDocumentUpload/ContactDetailDocumentUpload.vue'
  );
const UsersPage = () => import(/* webpackChunkName: "page-users" */ '@/views/pages/Users/Users.vue');
const UsersNewPage = () =>
  import(/* webpackChunkName: "page-users-new" */ '@/views/pages/Users/UserDetail/UserDetail.vue');
const ContactClientAssociationPage = () =>
  import(
    /* webpackChunkName: "page-contact-client-associate" */ '@/views/pages/Contacts/AssociateContactClient/AssociateContactClient.vue'
  );
const ContactTaskAssociationPage = () =>
  import(
    /* webpackChunkName: "page-contact-task-associate" */ '@/views/pages/Contacts/AssociateContactTask/AssociateContactTask.vue'
  );
const ContactSitesAssociationPage = () =>
  import(
    /* webpackChunkName: "page-contact-site-associate" */ '@/views/pages/Contacts/AssociateContactSites/AssociateContactSites.vue'
  );
const CustomerContactDetail = () =>
  import(
    /* webpackChunkName: "page-customer-contact-detail" */ '@/views/pages/Customers/CustomerDetail/CustomerDetailContacts/CustomerContactDetail/CustomerContactDetail.vue'
  );
const CustomerDocumentUpload = () =>
  import(
    /* webpackChunkName: "page-customer-document-upload" */ '@/views/pages/Customers/CustomerDetail/CustomerDetailDocuments/CustomerDetailDocumentsUpload/CustomerDetailDocumentsUpload.vue'
  );
const BillingDocumentUpload = () =>
  import(
    /* webpackChunkName: "page-customer-billing-document-upload" */ '@/views/pages/Customers/CustomerDetail/CustomerBilling/CustomerDetailBillingDocumentsUpload/CustomerDetailBillingDocumentsUpload.vue'
  );
const WorklogsPage = () => import(/* webpackChunkName: "page-worklogs" */ '@/views/pages/Worklogs/Worklogs.vue');
const DocumentsListPage = () =>
  import(/* webpackChunkName: "page-documents-list" */ '@/views/pages/Documents/DocumentsList/DocumentsList.vue');
const DocumentsBinPage = () =>
  import(/* webpackChunkName: "page-documents-bin" */ '@/views/pages/Documents/DocumentsBin/DocumentsBin.vue');
const DocumentsDetailPage = () =>
  import(/* webpackChunkName: "page-documents-detail" */ '@/views/pages/Documents/DocumentDetail/DocumentDetail.vue');

const PersonnelListPage = () =>
  import(/* webpackChunkName: "page-personnel-list" */ '@/views/pages/Personnel/PersonnelList/PersonnelList.vue');

const PersonnelDetailPage = () =>
  import(/* webpackChunkName: "page-personnel-detail" */ '@/views/pages/Personnel/PersonnelDetail/PersonnelDetail.vue');
const PersonnelDetailDocumentUploadPage = () =>
  import(
    /* webpackChunkName: "page-personnel-detail-document-upload" */ '@/views/pages/Personnel/PersonnelDetail/PersonnelDetailDocuments/PersonnelDetailDocumentUpload/PersonnelDetailDocumentUpload.vue'
  );
const ContactRolesListPage = () =>
  import(
    /* webpackChunkName: "page-contact-roles-list" */ '@/views/pages/Contacts/ContactRoles/ContactRolesList/ContactRolesList.vue'
  );
const ContactRolesEditPage = () =>
  import(
    /* webpackChunkName: "page-contact-roles-edit" */ '@/views/pages/Contacts/ContactRoles/ContactRolesEdit/ContactRolesEdit.vue'
  );
const ServiceTranslationDetailPage = () =>
  import(
    /* webpackChunkName: "page-service-translation-detail" */ '@/views/pages/ServiceTranslations/ServiceTranslationDetail/ServiceTranslationDetail.vue'
  );
const ServiceTranslationPeriodicDetailPage = () =>
  import(
    /* webpackChunkName: "page-service-translation-periodic-detail" */ '@/views/pages/ServiceTranslations/PeriodicTranslationDetail/PeriodicTranslationDetail.vue'
  );
const ServicesTranslationListPage = () =>
  import(
    /* webpackChunkName: "page-services-translation-list" */ '@/views/pages/ServiceTranslations/ServicesTranslationList/ServicesTranslationList.vue'
  );
const CommunicationsListPage = () =>
  import(/* webpackChunkName: "page-communications-list" */ '@/views/pages/Communications/Communications.vue');
const CommunicationDetailPage = () =>
  import(
    /* webpackChunkName: "page-communications-detail" */ '@/views/pages/Communications/CommunicationDetail/CommunicationDetail.vue'
  );
const TicketsListPage = () =>
  import(/* webpackChunkName: "page-tickets-list" */ '@/views/pages/Tickets/TicketsList/TicketsList.vue');
const TicketsDetailPage = () =>
  import(/* webpackChunkName: "page-tickets-detail" */ '@/views/pages/Tickets/TicketsDetail/TicketsDetail.vue');
const TicketHandlePage = () =>
  import(/* webpackChunkName: "page-handle-ticket" */ '@/views/pages/Tickets/TicketHandle/TicketHandle.vue');
const SettingsPage = () => import(/* webpackChunkName: "page-settings" */ '@/views/pages/Settings/Settings.vue');
const CustomersRequestsPage = () =>
  import(/* webpackChunkName: "page-contradictory-request" */ '@/views/pages/CustomersRequests/CustomersRequests.vue');

const CustomerRequestDetailPage = () =>
  import(
    /* webpackChunkName: "page-customer-request-detail" */ '@/views/pages/CustomersRequests/CustomerRequestDetail/CustomerRequestDetail.vue'
  );
const JobTaskAtiManagerDetailPage = () =>
  import(
    /* webpackChunkName: "page-ati-manager-detail" */ '@/views/pages/JobTasks/JobTaskDetail/AtiManagerDetail/AtiManagerDetail.vue'
  );
const AtiManagerSiteAssociationsPage = () =>
  import(
    /* webpackChunkName: "page-atimanager-site-associations" */ '@/views/pages/JobTasks/JobTaskDetail/JobTaskDetailAtiManagers/AtiManagerSiteAssociations/AtiManagerSiteAssociations.vue'
  );
const NewsPage = () => import(/* webpackChunkName: "page-news" */ '@/views/pages/News/News.vue');
const NewsPiecePage = () =>
  import(/* webpackChunkName: "page-news-piece" */ '@/views/pages/News/NewsPiece/NewsPiece.vue');
const SurveyListPage = () => import(/* webpackChunkName: "page-survey-list" */ '@/views/pages/Surveys/SurveyList.vue');
const SurveyDetailPage = () =>
  import(/* webpackChunkName: "page-survey-detail" */ '@/views/pages/Surveys/SurveyDetail/SurveyDetail.vue');

const SurveyAnswerDetailPage = () =>
  import(
    /* webpackChunkName: "page-survey-answers-detail" */ '@/views/pages/Surveys/SurveyAnswersDetail/SurveyAnswersDetail.vue'
  );
const RealEstateFieldsPage = () =>
  import(
    /* webpackChunkName: "page-real-estate-fields-list" */ '@/views/pages/RealEstate/RealEstateFieldsList/RealEstateFieldsList.vue'
  );
const RealEstateFieldDetailPage = () =>
  import(
    /* webpackChunkName: "page-real-estate-field-detail" */ '@/views/pages/RealEstate/RealEstateFieldsList/RealEstateFieldDetail/RealEstateFieldDetail.vue'
  );

const SiteEquipmentsListPage = () =>
  import(
    /* webpackChunkName: "page-site-equipments-list" */ '@/views/pages/SiteEquipments/SiteEquipmentsList/SiteEquipmentsList.vue'
  );

const SiteEquipmentsDetailPage = () =>
  import(
    /* webpackChunkName: "page-site-equipments-detail" */ '@/views/pages/SiteEquipments/SiteEquipmentsDetail/SiteEquipmentsDetail.vue'
  );

const SiteEquipmentDetailDocumentUploadPage = () =>
  import(
    /* webpackChunkName: "page-site-equipment-detail-document-upload" */ '@/views/pages/SiteEquipments/SiteEquipmentsDetail/SiteEquipmentDetailDocuments/SiteEquipmentDocumentUpload/SiteEquipmentDetailDocumentUpload.vue'
  );

const EconomicsPage = () => import(/* webpackChunkName: "page-economics" */ '@/views/pages/Economics/Economics.vue');
const VariationsPage = () =>
  import(/* webpackChunkName: "page-variations" */ '@/views/pages/Variations/Variations.vue');
const RoomsPage = () => import(/* webpackChunkName: "page-rooms" */ '@/views/pages/Rooms/RoomsPage.vue');
const ReportsPage = () => import(/* webpackChunkName: "page-reports" */ '@/views/pages/Reports/Reports.vue');
const ReportNewPage = () =>
  import(/* webpackChunkName: "page-report-new" */ '@/views/pages/Reports/ReportNew/ReportNew.vue');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'main-container',
    redirect: { path: '/dashboard' },
    component: TheContainer,
    children: [
      {
        path: '/dashboard',
        name: 'page-dashboard',
        component: Dashboard,
        meta: {
          title: `${APP_TITLE} - Dashboard`,
          requiresAuth: true,
        },
      },
      {
        path: '/sync',
        name: 'page-sync',
        component: SyncPage,
        meta: {
          title: `${APP_TITLE} - Sync`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers',
        name: 'page-customers',
        component: CustomersPage,
        meta: {
          title: `${APP_TITLE} - Clients`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_CLIENTS],
        },
      },
      {
        path: '/customers/toactivate',
        name: 'page-customers-toactivate',
        component: CustomersToActivatePage,
        meta: {
          title: `${APP_TITLE} - Clients`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/activate-customer',
        name: 'page-activate-customer',
        component: ActivateCustomerPage,
        meta: {
          title: `${APP_TITLE} - Activate Customer`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/detail/:id/activate-user/',
        name: 'page-activate-customer-user',
        component: ActivateCustomerPage,
        meta: {
          title: `${APP_TITLE} - Activate Customer User`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/detail/:id/user/:userId',
        name: 'page-edit-customer-user',
        component: ActivateCustomerPage,
        meta: {
          title: `${APP_TITLE} - Edit User`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/detail/:id',
        name: 'page-customer-detail',
        component: CustomerDetailPage,
        meta: {
          title: `${APP_TITLE} - Customer Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_CLIENTS],
        },
      },
      {
        path: '/customers/detail/:id/contact/:contactId',
        name: 'page-customer-contact-detail',
        component: CustomerContactDetail,
        meta: {
          title: `${APP_TITLE} - New Contact`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/detail/:id/document/:documentid',
        name: 'page-customer-document-upload',
        component: CustomerDocumentUpload,
        meta: {
          title: `${APP_TITLE} - Upload document`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customers/detail/:id/billing-document/:documentid',
        name: 'page-billing-document-upload',
        component: BillingDocumentUpload,
        meta: {
          title: `${APP_TITLE} - Upload billing document`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/jobtasks/detail/:jobId/worklogs',
        name: 'page-jobtasks-worklogs',
        component: WorklogsPage,
        meta: {
          title: `${APP_TITLE} - Timbrature`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customer-requests',
        name: 'page-contradictory-requests',
        component: CustomersRequestsPage,
        meta: {
          title: `${APP_TITLE} - Richieste contraddittorio`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/customer-requests/:id',
        name: 'page-customer-request-detail',
        component: CustomerRequestDetailPage,
        meta: {
          title: `${APP_TITLE} - Richiesta contraddittorio`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/change-password',
        name: 'page-change-password',
        component: ChangePasswordPage,
        meta: {
          title: `${APP_TITLE} - Change password`,
          requiresAuth: false,
          //          allowedRoles: ['Administrator', 'Customer'],
        },
      },
      {
        path: '/contacts',
        name: 'page-contacts-list',
        component: ContactsListPage,
        meta: {
          title: `${APP_TITLE} - Contacts List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/detail/:id',
        name: 'page-contact-detail',
        component: ContactDetailPage,
        meta: {
          title: `${APP_TITLE} - Contact detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/detail/:id/document/:documentId',
        name: 'page-contact-document-detail',
        component: ContactDetailDocumentUploadPage,
        meta: {
          title: `${APP_TITLE} - Contact Document Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/associate-to-client/:id',
        name: 'page-contact-client-association',
        component: ContactClientAssociationPage,
        meta: {
          title: `${APP_TITLE} - Contact-client association`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/associate-to-task/:id',
        name: 'page-contact-task-association',
        component: ContactTaskAssociationPage,
        meta: {
          title: `${APP_TITLE} - Contact-task association`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/associate-to-sites/:id',
        name: 'page-contact-sites-association',
        component: ContactSitesAssociationPage,
        meta: {
          title: `${APP_TITLE} - Contact-sites association`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/roles/list',
        name: 'page-contact-roles-list',
        component: ContactRolesListPage,
        meta: {
          title: `${APP_TITLE} - Contact roles list`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/contacts/roles/edit/:role',
        name: 'page-contact-roles-edit',
        component: ContactRolesEditPage,
        meta: {
          title: `${APP_TITLE} - Contact roles edit`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/users',
        name: 'page-users',
        component: UsersPage,
        meta: {
          title: `${APP_TITLE} - Users`,
          requiresAuth: true,
          allowedRoles: ['Administrator'],
        },
      },
      {
        path: '/users/detail/new',
        name: 'page-users-new',
        component: UsersNewPage,
        meta: {
          title: `${APP_TITLE} - Users New`,
          requiresAuth: true,
          allowedRoles: ['Administrator'],
        },
      },
      {
        path: '/jobtasks',
        name: 'page-jobtasks-list',
        component: JobTasksListPage,
        meta: {
          title: `${APP_TITLE} - JobTasks List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_JOBTASKS],
        },
      },
      {
        path: '/jobtasks/detail/:jobTaskId',
        name: 'page-jobtask-detail',
        component: JobTasksDetailPage,
        meta: {
          title: `${APP_TITLE} - JobTasks Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_JOBTASKS],
        },
      },
      {
        path: '/jobtasks/detail/:jobTaskId/ati-manager/:atiManagerId',
        name: 'page-jobtask-ati-manager-detail',
        component: JobTaskAtiManagerDetailPage,
        meta: {
          title: `${APP_TITLE} - JobTasks Ati manager detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/jobtasks/detail/:jobTaskId/ati-manager/:atiManagerId/sites',
        name: 'page-jobtask-ati-manager-sites-associations',
        component: AtiManagerSiteAssociationsPage,
        meta: {
          title: `${APP_TITLE} - JobTasks Ati manager Sites`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/sites',
        name: 'page-sites-list',
        component: SitesListPage,
        meta: {
          title: `${APP_TITLE} - Sites List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SITES],
        },
      },
      {
        path: '/sites/detail/:siteCode',
        name: 'page-sites-detail',
        component: SitesDetailPage,
        meta: {
          title: `${APP_TITLE} - Site Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SITES],
        },
      },
      {
        path: '/documents',
        name: 'page-documents-list',
        component: DocumentsListPage,
        meta: {
          title: `${APP_TITLE} - Documents List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/documents/bin',
        name: 'page-documents-bin',
        component: DocumentsBinPage,
        meta: {
          title: `${APP_TITLE} - Documents Bin`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/documents/detail/:documentId',
        name: 'page-document-detail',
        component: DocumentsDetailPage,
        meta: {
          title: `${APP_TITLE} - Document detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/services',
        name: 'page-services-translations-list',
        component: ServicesTranslationListPage,
        meta: {
          title: `${APP_TITLE} - Services translation List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/services/detail/:id',
        name: 'page-service-translations-detail',
        component: ServiceTranslationDetailPage,
        meta: {
          title: `${APP_TITLE} - Service translation edit`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/services/periodic-detail/:id',
        name: 'page-service-translations-periodic-detail',
        component: ServiceTranslationPeriodicDetailPage,
        meta: {
          title: `${APP_TITLE} - Service periodic translation edit`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/personnel',
        name: 'page-personnel-list',
        component: PersonnelListPage,
        meta: {
          title: `${APP_TITLE} - Personnel List`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/personnel/detail/:id',
        name: 'page-personnel-detail',
        component: PersonnelDetailPage,
        meta: {
          title: `${APP_TITLE} - Personnel Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/personnel/detail/:id/document/:documentId',
        name: 'page-personnel-document-detail',
        component: PersonnelDetailDocumentUploadPage,
        meta: {
          title: `${APP_TITLE} - Personnel Document Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/communications',
        name: 'page-communications-list',
        component: CommunicationsListPage,
        meta: {
          title: `${APP_TITLE} - Communications list`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/communications/detail/:id',
        name: 'page-communication-detail',
        component: CommunicationDetailPage,
        meta: {
          title: `${APP_TITLE} - Communications detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/tickets',
        name: 'page-tickets-list',
        component: TicketsListPage,
        meta: {
          title: `${APP_TITLE} - Tickets list`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_TICKETS],
        },
      },
      {
        path: '/tickets/:anonymousAccessToken',
        name: 'page-manager-tickets-list',
        component: TicketsListPage,
        meta: {
          title: `${APP_TITLE} - Tickets list`,
        },
      },
      {
        path: '/tickets/detail/:ticketId',
        name: 'page-tickets-detail',
        component: TicketsDetailPage,
        meta: {
          title: `${APP_TITLE} - Ticket detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_TICKETS],
        },
      },
      {
        path: '/tickets/handle/:anonymousAccessToken',
        name: 'page-ticket-handle',
        component: TicketHandlePage,
        meta: {
          title: `${APP_TITLE} - Handle ticket`,
        },
      },
      {
        path: '/settings',
        name: 'page-settings',
        component: SettingsPage,
        meta: {
          title: `${APP_TITLE} - Settings`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/news',
        name: 'page-news',
        component: NewsPage,
        meta: {
          title: `${APP_TITLE} - News`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/news/detail/:id?',
        name: 'page-news-piece',
        component: NewsPiecePage,
        meta: {
          title: `${APP_TITLE} - News piece`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/surveys',
        name: 'page-survey-list',
        component: SurveyListPage,
        meta: {
          title: `${APP_TITLE} - Surveys`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/surveys/detail/:id?',
        name: 'page-survey-detail',
        component: SurveyDetailPage,
        meta: {
          title: `${APP_TITLE} - Survey detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/surveys/answers-detail/:id?',
        name: 'page-survey-answers',
        component: SurveyAnswerDetailPage,
        meta: {
          title: `${APP_TITLE} - Survey answer detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/real-estate-fields',
        name: 'page-real-estate-fields',
        component: RealEstateFieldsPage,
        meta: {
          title: `${APP_TITLE} - QGIS`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/real-estate-fields/:id',
        name: 'page-real-estate-field-detail',
        component: RealEstateFieldDetailPage,
        meta: {
          title: `${APP_TITLE} - QGIS field detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/404',
        name: 'page-404',
        component: Page404,
        meta: {
          title: `${APP_TITLE} - Table`,
        },
      },
      {
        path: '/users/detail/:userId',
        name: 'page-edit-user',
        component: UsersNewPage,
        meta: {
          title: `${APP_TITLE} - Edit User`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/site-equipments',
        name: 'page-site-equipments-list',
        component: SiteEquipmentsListPage,
        meta: {
          requiresAuth: true,
          title: `${APP_TITLE} - Site equipments`,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/site-equipments/detail/:siteEquipmentId',
        name: 'page-site-equipment-detail',
        component: SiteEquipmentsDetailPage,
        meta: {
          requiresAuth: true,
          title: `${APP_TITLE} - Site equipment`,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/site-equipment/detail/:siteEquipmentId/document/:documentId',
        name: 'page-site-equipment-document-detail',
        component: SiteEquipmentDetailDocumentUploadPage,
        meta: {
          title: `${APP_TITLE} - Site Equipment Document Detail`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/page-economics',
        name: 'page-economics',
        component: EconomicsPage,
        meta: {
          title: `${APP_TITLE} - Economics`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/page-variations',
        name: 'page-variations',
        component: VariationsPage,
        meta: {
          title: `${APP_TITLE} - Variations`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/page-rooms',
        name: 'page-rooms',
        component: RoomsPage,
        meta: {
          title: `${APP_TITLE} - Rooms`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
        },
      },
      {
        path: '/page-reports',
        name: 'page-reports',
        component: ReportsPage,
        meta: {
          title: `${APP_TITLE} - Reports`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_REPORTS],
        },
      },
      {
        path: '/page-reports/new',
        name: 'page-report-new',
        component: ReportNewPage,
        meta: {
          title: `${APP_TITLE} - New report`,
          requiresAuth: true,
          allowedRoles: ['Administrator', 'Pulinet'],
          allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_REPORTS],
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'page-login',
    component: LoginPage,
    meta: {
      title: `${APP_TITLE} - Login`,
    },
  },
  {
    path: '/recover-password',
    name: 'page-recover-password',
    component: RecoverPasswordPage,
    meta: {
      title: `${APP_TITLE} - Recover password`,
    },
  },
  {
    path: '/reset-password',
    name: 'page-reset-password',
    component: ResetPasswordPage,
    meta: {
      title: `${APP_TITLE} - Reset password`,
    },
  },
  {
    path: '/enable-user',
    name: 'page-enable-user',
    component: EnableUserPage,
    meta: {
      title: `${APP_TITLE} - Enable user`,
    },
  },
];

export default routes;
